import { render, staticRenderFns } from "./HTMLTemplateEditor.vue?vue&type=template&id=dc88e214&scoped=true&"
import script from "./HTMLTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./HTMLTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./HTMLTemplateEditor.vue?vue&type=style&index=0&id=dc88e214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc88e214",
  null
  
)

export default component.exports